import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DRIVERS_DATA, FETCH_DRIVERS_DETAILS_DATA } from "./actionTypes";
import {
  fetchDriversSuccess,
  fetchDriversFailure,
  fetchDriversDetailsSuccess,
  fetchDriversDetailsFailure
} from "./actions";

function* fetchDriversDataSaga(action) {
  try {
    const { page = 1, limit = 10 } = action.payload || {};
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const url = process.env.REACT_APP_WEB_APP_URL + `/api/web/drivers?${params.toString()}`;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const payload = response.data;
    if (payload.total == null && Array.isArray(payload.data)) {
      payload.total = payload.data.length;
    }
    yield put(fetchDriversSuccess(payload));
  } catch (error) {
    yield put(fetchDriversFailure(error.message));
  }
}

function* fetchDriversDetailsDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/drivers/${id}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    yield put(fetchDriversDetailsSuccess(response.data));
  } catch (error) {
    yield put(fetchDriversDetailsFailure({
      message: error?.response?.data?.message || error.message,
      status: error?.response?.status
    }));
  }
}

export default function* driversSaga() {
  yield takeEvery(FETCH_DRIVERS_DATA, fetchDriversDataSaga);
  yield takeEvery(FETCH_DRIVERS_DETAILS_DATA, fetchDriversDetailsDataSaga); 
}
